<template>
    <activation-tasks-summary-provider v-slot="{ briefs, close }" style="height: 100%">
        <activation-tasks-summary-view :briefs="briefs" @close="close" />
    </activation-tasks-summary-provider>
</template>

<script>
    import ActivationTasksSummaryProvider from '../providers/ActivationTasksSummaryProvider.vue';
    import ActivationTasksSummaryView from '../data-views/activation-briefs/ActivationTasksSummaryView.vue';

    export default {
        name: 'ActivationTasksSummaryRouterView',
        components: {
            ActivationTasksSummaryProvider,
            ActivationTasksSummaryView
        }
    };
</script>
